import { ConfigProvider } from "antd";
import { useState, createContext, useContext } from "react";
import { Outlet } from "react-router-dom";

// Default branding images
const DEFAULT_BACKGROUND_IMAGE = "/c1-fitness-bg.webp";
const DEFAULT_LOGO_IMAGE = "/c1-logo-white.svg";

// Context for dynamic branding
interface BrandingContextType {
  backgroundImageUrl: string;
  logoImageUrl: string;
  setBackgroundImageUrl: (url: string) => void;
  setLogoImageUrl: (url: string) => void;
}

const BrandingContext = createContext<BrandingContextType>({
  backgroundImageUrl: DEFAULT_BACKGROUND_IMAGE,
  logoImageUrl: DEFAULT_LOGO_IMAGE,
  setBackgroundImageUrl: () => {},
  setLogoImageUrl: () => {},
});

export const useBranding = () => useContext(BrandingContext);

export const PublicLayout = () => {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(
    DEFAULT_BACKGROUND_IMAGE
  );
  const [logoImageUrl, setLogoImageUrl] = useState(DEFAULT_LOGO_IMAGE);

  console.log("backgroundImageUrl", backgroundImageUrl);
  console.log("logoImageUrl", logoImageUrl);
  return (
    <BrandingContext.Provider
      value={{
        backgroundImageUrl,
        logoImageUrl,
        setBackgroundImageUrl,
        setLogoImageUrl,
      }}
    >
      <ConfigProvider
        theme={{
          token: {
            colorBgContainerDisabled: "#2A2E52",
            colorTextDisabled: "#888888",
            colorPrimary: "#1E88E5",
            colorText: "#FFFFFF",
            fontFamily: "gilroy",
            colorBgContainer: "#2A2E52",
            colorBorder: "transparent",
            colorBgElevated: "#100E1C",
          },
        }}
      >
        <style>
          {`
          .survey-checkbox .ant-checkbox-inner {
            background-color: #2A2E52;
            border-color: #4A4E72;
          }
          .survey-checkbox .ant-checkbox-checked .ant-checkbox-inner {
            background-color: #1E88E5;
            border-color: #1E88E5;
          }
          .survey-checkbox span {
            color: #FFFFFF;
          }
          .ant-select-selector {
            background-color: #2A2E52 !important;
            border-color: #4A4E72 !important;
          }
          .ant-select-selection-item {
            color: #FFFFFF !important;
          }
        `}
        </style>
        <div
          className="flex relative min-h-screen bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url('${backgroundImageUrl}')` }}
        >
          <div className="absolute h-full inset-0 bg-black/40 pointer-events-none" />
          <div className="grid place-content-center max-w-xl mx-auto p-4 relative w-full sm:p-6 md:p-8">
            <Outlet />
          </div>
        </div>
      </ConfigProvider>
    </BrandingContext.Provider>
  );
};
